if (!customElements.get('product-tabs')) {
  customElements.define(
    'product-tabs',
    class ProductTabs extends HTMLDivElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.tabPanels = this.querySelector('.tabs__panels');
        this.tabBtns = this.querySelectorAll('.tabs__btn');
        this.currentIndex = 0;
        this.init();
      }

      init() {
        this.tabBtns.forEach((btn) => {
          btn.addEventListener('click', this.onClick.bind(this));
          btn.addEventListener('keydown', this.onKeydown.bind(this));
        });
        this.updateTabState(this.currentIndex);

        if (Shopify.designMode) {
          this.addEventListener('shopify:block:select', (e) => {
            if (e.detail.sectionId != this.sectionId) return;
            let { target } = e;
            const index = Number(target.dataset.index);

            this.setActiveTab(index);
          });
        }
      }

      onClick(e) {
        e.preventDefault();
        const { target } = e;
        const button = target.closest('button');
        const index = Number(button.dataset.index);
        this.setActiveTab(index);
      }

      onKeydown(e) {
        const currentIndex = Array.from(this.tabBtns).indexOf(e.currentTarget);
        if (currentIndex < 0) return;

        let nextIndex = currentIndex;
        switch (e.key) {
          case 'ArrowRight':
            nextIndex = (currentIndex + 1) % this.tabBtns.length;
            break;
          case 'ArrowLeft':
            nextIndex = (currentIndex - 1 + this.tabBtns.length) % this.tabBtns.length;
            break;
          case 'Home':
            nextIndex = 0;
            break;
          case 'End':
            nextIndex = this.tabBtns.length - 1;
            break;
          default:
            return;
        }

        e.preventDefault();
        this.setActiveTab(nextIndex);
        this.tabBtns[nextIndex].focus();
      }

      updateTabState(index) {
        this.tabBtns.forEach((btn, btnIndex) => {
          const isActive = btnIndex === index;
          btn.classList.toggle('active', isActive);
          btn.setAttribute('aria-selected', String(isActive));
          btn.tabIndex = isActive ? 0 : -1;
        });
      }

      setActiveTab(index) {
        if (!this.tabBtns[index]) return;
        if (this.currentIndex === index) return;

        let newTab = this.tabPanels.querySelector(`.tabs__panel[data-index="${index}"]`);

        if (!newTab) {
          const panelTemplate = this.tabPanels.querySelector(`template[data-index="${index}"]`);
          if (!panelTemplate) return;

          newTab = panelTemplate.content.cloneNode(true).firstElementChild;
          newTab.hidden = true;
          this.tabPanels.appendChild(newTab);
        } else {
          const contentTemplate = newTab.querySelector(`template[data-index="${index}"]`);
          if (contentTemplate) {
            contentTemplate.replaceWith(contentTemplate.content.cloneNode(true));
          }
        }

        this.updateTabState(index);
        this.tabPanels.querySelectorAll('.tabs__panel').forEach((panel) => {
          panel.hidden = true;
        });
        const translateY = FoxTheme.config.motionReduced ? 0 : 2.5;

        FoxTheme.Motion.animate(newTab, { transform: `translateY(${translateY}rem)`, opacity: 0.01 }, { duration: 0 });

        newTab.hidden = false;
        this.fixBlurryImagesOnSafari(newTab);

        setTimeout(() => {
          FoxTheme.Motion.animate(
            newTab,
            { transform: 'translateY(0)', opacity: 1 },
            { duration: 0.5, delay: this.animationDelay, easing: [0, 0, 0.3, 1] }
          );
        }, 50);

        this.currentIndex = index;

        this.dispatchEvent(
          new CustomEvent('tabChange', {
            bubbles: true,
            detail: { selectedIndex: index, selectedTab: newTab },
          })
        );
      }

      /**
       * Fix for Safari 15.6: force images to reload with correct size after becoming visible
       * @param {*} container
       * @returns
       */
      fixBlurryImagesOnSafari(tab) {
        const isOldSafari =
          /^((?!chrome|android).)*safari/i.test(navigator.userAgent) && navigator.userAgent.includes('Version/15.');

        if (!isOldSafari) return;

        if (tab.classList.contains('images-loaded')) return;
        tab.classList.add('images-loaded');

        const images = tab.querySelectorAll('img[srcset]');
        images.forEach((img) => {
          const src = img.currentSrc || img.src;
          img.srcset = img.srcset; // Trick to trigger evaluation.
          img.src = ''; // Force reload.
          img.src = src;
        });
      }
    },
    { extends: 'div' }
  );
}
